import {
  SlRating
} from "./chunk.2WQ7JNXK.js";

// src/components/rating/rating.ts
var rating_default = SlRating;
SlRating.define("sl-rating");

export {
  rating_default
};
